"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const applicationStateConstants_1 = __importDefault(require("../applicationState/applicationStateConstants"));
const cleanDatabasePath_1 = __importDefault(require("../FirebaseDatabaseCache/cleanDatabasePath"));
const getValueByPathFromUnknown_1 = __importDefault(require("../shared/getValueByPathFromUnknown"));
const syncAppLocalStorage = async ({ appStateBefore, appStateAfter, removeItemFromLocalStorage, setItemFromLocalStorage, actionType, }) => {
    const { appId } = appStateAfter;
    const beforeLocalData = appStateBefore.localStorage.data;
    const afterLocalData = appStateAfter.localStorage.data;
    if (appId
        && beforeLocalData !== afterLocalData) {
        if (!afterLocalData) {
            await removeItemFromLocalStorage(`dbLocalStorage:${appId}`);
        }
        else {
            await setItemFromLocalStorage(`dbLocalStorage:${appId}`, JSON.stringify(afterLocalData));
        }
        const { listeners, lastUpdates } = appStateAfter.localStorage;
        if (actionType === applicationStateConstants_1.default.UPDATE_LOCAL_STORAGE && lastUpdates) {
            const originPaths = Object.keys(lastUpdates);
            Object.entries(listeners).forEach(([path, listenersArray]) => {
                if (!listenersArray) {
                    return;
                }
                const hasPath = originPaths.find((originPath) => originPath.startsWith(path));
                if (hasPath) {
                    const formatedPath = (0, cleanDatabasePath_1.default)(path);
                    const dataOnListeners = (0, getValueByPathFromUnknown_1.default)(afterLocalData, formatedPath.split('/'));
                    listenersArray.forEach((listener) => {
                        listener(dataOnListeners);
                    });
                }
            });
        }
        else if (actionType === applicationStateConstants_1.default.CLEAN_LOCAL_STORAGE) {
            Object.entries(listeners).forEach(([, listenersArray]) => {
                if (listenersArray) {
                    listenersArray.forEach((listener) => {
                        listener(undefined);
                    });
                }
            });
        }
    }
};
exports.default = syncAppLocalStorage;
